import { ChristmasOpeningHours } from './christmas-opening-hours'

export default ChristmasOpeningHours
